module.exports = __webpack_public_path__ + "static/media/icon-resources.549868f0.svg";